import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from 'components/@mui-extend/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { experienceStatus } from 'config/constants'

const styles = makeStyles(({ spacing, fontWeight, fontSize }) => ({
  badge: {
    borderRadius: 5,
    padding: spacing(0.5, 1.5),
    width: `auto`,
  },
  edition: {
    background: `#98D7E4`,
    color: `#0D3B45`,
  },
  approved: {
    background: `#B3F0D3`,
    color: `#0B5030`,
  },
  rejected: {
    background: `#F2B2A9`,
    color: `#8B1C0A`,
  },
  checking: {
    background: `#E3D7FF`,
    color: `#3D188E`,
  },
  paused: {
    background: `#FDEEC1`,
    color: `#694F06`,
  },
  nonactive: {
    background: `#E7E7E7`,
    color: `#464646`,
  },
  upgrading: {
    background: `#B6CFF6`,
    color: `#0D3472`,
  },
  updagradechecking: {
    background: `#E3D7FF`,
    color: `#3D188E`,
  },
}))

export default function ExperienceStatusBadge({ status }) {
  const classes = styles()
  const { label, className } = experienceStatus[status]
  return (
    <Grid
      container
      alignItems="center"
      justify="space-between"
      className={`${classes.badge} ${classes[className]}`}
    >
      <Typography title={label} size={12} align="center" />
    </Grid>
  )
}
